<style>
.input-readonly > div > .vs-inputx {
  background-color: #e6e6e6;
}
</style>
<template>
  <div class="vx-col w-5/6 ml-auto mr-auto">
    <span>
      <h4 class="mb-5">Advance Invoice</h4>
    </span>
    <vs-divider>Invoice</vs-divider>
    <div class="vx-row mb-2">
      <div class="vx-col w-1/2">
        <vs-input
          class="w-full input-readonly"
          label="Invoice Code"
          name="Invoice Code"
          readonly
          :value="advanceInvoice ? advanceInvoice.code : ''"
        />
      </div>
      <div class="vx-col w-1/2">
        <div class="vx-col w-full">
          <span class="text-sm">Invoice Date</span>
        </div>
        <datepicker
          class="w-full"
          v-validate="'required'"
          :inline="false"
          name="invoice date"
          v-model="invoiceDate"
          :disabled="true"
          placeholder="Select invoice date"
        ></datepicker>
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-1/2">
        <vs-input
          class="w-full input-readonly"
          label="Invoice Total"
          name="Invoice Total"
          :value="
            priceFormat(
              table.line && table.line.length > 0
                ? table.line[0].advance_amount
                : 0
            )
          "
          readonly
        />
      </div>
      <div class="vx-col w-1/2">
        <vs-input
          class="w-full input-readonly"
          label="External Code"
          name="External Code"
          :value="advanceInvoice ? advanceInvoice.external_code : ''"
          readonly
        />
      </div>
    </div>
    <vs-divider>Supplier</vs-divider>
    <div class="vx-row mb-2"></div>
    <div class="vx-row mb-2">
      <div class="vx-col w-1/2">
        <vs-input
          class="w-full input-readonly"
          label="Supplier Code"
          name="Supplier Code"
          :value="advanceInvoice ? advanceInvoice.partner_code : ''"
          readonly
        />
      </div>
      <div class="vx-col w-1/2">
        <vs-input
          class="w-full input-readonly"
          label="Supplier Name"
          name="Vendor"
          readonly
          :value="advanceInvoice ? advanceInvoice.partner_name : ''"
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Supplier Address"
          name="Supplier Address"
          v-model="this.supplierAddress"
          readonly
        />
      </div>
    </div>
    <vs-divider>Purchae Order</vs-divider>
    <vs-table stripe border description :sst="true" :data="table.line">
      <template slot="thead">
        <th>PO Code</th>
        <th>PO Date</th>
        <th>PO Tax</th>
        <th>PO Discount</th>
        <th>PO Total</th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          :class="data[indextr].class"
        >
          <vs-td :data="data[indextr].code">
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ tr.document_code }}</span>
            </div>
          </vs-td>
          <vs-td> {{ globalDateFormat(tr.document_date) }}</vs-td>
          <vs-td> {{ priceFormat(tr.document_tax_amount) }}</vs-td>
          <vs-td> {{ priceFormat(tr.document_discount_amount) }}</vs-td>
          <vs-td>
            {{
              priceFormat(tr.document_total_amount + tr.document_tax_amount)
            }}</vs-td
          >
        </vs-tr>
      </template>
    </vs-table>
    <vs-divider></vs-divider>

    <div class="vx-row mb-2 gap-2">
      <!-- <div class="vx-col w-1/2">
        <vs-input
          v-validate="'required'"
          class="w-full"
          label="Account Number"
          name="Account Number"
          v-model="account_number"
          placeholder="Account Number"
        />
        <span
          class="text-danger text-sm"
          v-if="account_number == null && status_submit"
          >This field is required</span
        >
      </div> -->
      <div class="vx-col w-full">
        <div class="vx-col w-full">
          <span>Porpose Date Payment</span>
        </div>
        <div>
          <datepicker
            class="w-full"
            v-validate="'required'"
            :inline="false"
            name="Porpose Date"
            v-model="porpose_date"
            placeholder="Select Porpose Date"
          ></datepicker>
        </div>
      </div>
      <div class="vx-col w-full">
        <vs-input
          v-validate="'required'"
          class="w-full"
          label="Propose Value"
          name="Propose Value"
          v-model="total_value"
          @input="formatNumber()"
        />
        <span
          class="text-danger text-sm"
          v-if="total_value == 0 && status_submit"
          >This field is required</span
        >
      </div>
      <div class="vx-col w-full">
        <div class="vx-col w-full text-sm">
          <span>Supplier Bank</span>
        </div>
        <multiselect
          v-model="supplierBank"
          :options="optionBankName"
          :allow-empty="true"
          :group-select="false"
          :max-height="160"
          placeholder=" Type to search"
          track-by="ID"
          label="Name"
          name="Supplier Bank"
          v-validate="'required'"
          :disabled="false"
          @select="onSupplierBankSelected"
          class="w-full"
        >
          <template slot="singleLabel" slot-scope="dt">
            <span class="option__desc">
              <span class="option__title">{{ dt.option.Name }}</span>
            </span>
          </template>
        </multiselect>
        <span
          v-show="errors.has('Supplier Bank')"
          class="text-danger text-sm help is-danger"
        >
          {{ errors.first("Supplier Bank") }}
        </span>
      </div>

      <div class="vx-col w-full">
        <div class="vx-col w-full text-sm">
          <span>Supplier Account</span>
        </div>
        <multiselect
          class="selectExample"
          v-model="supplierAcount"
          :options="optionSupplierAccount"
          :allow-empty="true"
          :group-select="false"
          :max-height="160"
          placeholder=" Type to search"
          track-by="ID"
          :disabled="false"
          name="Supplier Account"
          v-validate="'required'"
          :custom-label="supplierAcoountQuery"
          @select="onSupplierAccountSelected"
        >
          <template slot="singleLabel" slot-scope="dt">
            <span class="option__desc">
              <span class="option__title"
                >{{ dt.option.AccountName }} -
                {{ dt.option.AccountNumber }}</span
              >
            </span>
          </template>

          <template slot="option" slot-scope="dt">
            <span class="option__desc">
              <span class="option__title"
                >{{ dt.option.AccountName }} -
                {{ dt.option.AccountNumber }}</span
              >
            </span>
          </template>
        </multiselect>
        <span
          v-show="errors.has('Supplier Account')"
          class="text-danger text-sm help is-danger"
        >
          {{ errors.first("Supplier Account") }}
        </span>
      </div>
      <!-- <vs-divider style="width: 100%; margin-left: 2%"
        ><b>Selected DN by Excel</b></vs-divider
      >
      <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
        <div class="vx-col sm:w-1/3 w-full">
          <span>File</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <div class="vx-col sm:w-4/5 w-full">
            <input
              id="fileSelectedDN"
              name="fileSelected"
              class="w-full inputx"
              type="file"
              ref="fileSelected"
              multiple="multiple"
              accept=".xlsx"
            />
          </div>
        </div>
      </div>
      <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
        <div class="vx-col sm:w-1/3 w-full">
          <span></span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <div class="vx-col sm:w-4/5 w-full">
            <vs-button class="mr-3 mb-2" @click="loadExcel">Selected</vs-button>
          </div>
        </div>
      </div>
      <vs-divider style="width: 100%; margin-left: 2%"
        ><b>Debit Note</b></vs-divider
      > -->
      <!-- <multiselect
        class="selectExample"
        v-model="debitNote"
        :options="optionDebitNote"
        :multiple="true"
        :max="maxSelectedDN"
        @remove="removeSelectedDN"
        @input="selectedDN"
        :allow-empty="true"
        :group-select="false"
        :max-height="160"
        :limit="5"
        placeholder=" Type to search"
        track-by="ID"
        label="Code"
        :disabled="false"
      >
        <template slot="singleLabel" slot-scope="dt">
          <span class="option__desc">
            <span class="option__title">{{ dt.option.Code }}</span>
          </span>
        </template>

        <template slot="option" slot-scope="dt">
          <div class="option__desc">
            <span class="option__title">{{
              dt.option.Code +
              " : " +
              parseFloat(
                parseFloat(dt.option.TotalDnValue).toFixed(2) -
                  parseFloat(dt.option.UsedDnValue)
              )
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}</span>
            <span class="option__small">
              <br />
              [{{
                dt.option.Type == "Return" || dt.option.Type == "Manual"
                  ? "Trade"
                  : dt.option.ClaimType
              }}
              , {{ dt.option.CreatedAt }}]
            </span>
          </div>
        </template>
      </multiselect>
      <div class="vx-col sm:w-3/3 w-full" v-if="debitNote.length > 0">
        <vs-list>
          <vs-list-item
            v-for="(item, i) in debitNote"
            :key="item.Code"
            :title="item.Code"
            :subtitle="
              parseFloat(
                parseFloat(item.TotalDnValue) - parseFloat(item.UsedDnValue)
              )
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
          >
            <div class="vx-row w-full">
              <div class="vx-col w-3/3">
                <vs-input
                  v-validate="'required'"
                  class="w-full"
                  label="Apply Value"
                  name="Apply Value"
                  v-model="applyValue[i]"
                  @keyup="handleMaxValue(i)"
                />
              </div>
            </div>
          </vs-list-item>
        </vs-list>
        <div class="vx-col sm:w-3/3 w-full">
          <div class="vx-col sm:w-4/5 w-full"></div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <span>Posting Date</span>
          </div>
          <div class="vx-col w-full">
            <datepicker
              class="w-full"
              v-validate="'required'"
              :inline="false"
              name="PostingDate"
              v-model="posting_date"
              placeholder="Select Posting Date"
            ></datepicker>
          </div>
        </div>
        <div class="vx-row sm:w-3/3 w-full">
          <div class="vx-col sm:w-2/3">
            <vs-button
              v-if="canApplyDN"
              class="mr-3 mb-2"
              @click="handleApplyDebitNote"
              >Apply Debit Note</vs-button
            >
          </div>
          <div class="vx-col sm:w-1/3">
            Total Selected :
            {{
              applyValue
                .reduce(
                  (a, b) =>
                    Number(a.toString().replace(/,/g, "")) +
                    Number(b.toString().replace(/,/g, "")),
                  0
                )
                .toString()
                .replace(/,/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}
          </div>
        </div>
      </div> -->
      <vs-divider style="width: 100%; margin-left: 2%"><b>Note</b></vs-divider>
      <vs-textarea v-model="note" />
      <vs-divider style="width: 100%; margin-left: 2%"
        ><b>Description</b></vs-divider
      >
      <vs-textarea v-model="description" />
      <vs-table
        stripe
        border
        description
        class="w-full"
        :sst="true"
        :data="table.data_payment"
      >
        <template slot="thead">
          <vs-td style="text-align: center"><b>Payment Account</b></vs-td>
          <vs-td style="text-align: center"><b>Payment Voucher</b></vs-td>
          <vs-td style="text-align: right"><b>Paid</b></vs-td>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            :class="data[indextr].class"
          >
            <vs-td style="text-align: center" :data="data[indextr].BankName">
              {{
                data[indextr].BankID == 0
                  ? data[indextr].Type == 2
                    ? "DN"
                    : "-"
                  : data[indextr].BankName + " " + data[indextr].AccountNumber
              }}
            </vs-td>
            <vs-td style="text-align: center">
              {{ data[indextr].ReferenceCode }}
            </vs-td>
            <vs-td style="text-align: right">
              {{
                 Math.round(data[indextr].PaidInvoiceValue).toString().replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  ","
                )
              }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-divider style="width: 100%; margin-left: 2%">Attachment</vs-divider>
      <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
        <div class="vx-col sm:w-1/3 w-full">
          <span>File</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <div class="vx-col sm:w-4/5 w-full">
            <input
              id="fileInput"
              name="file"
              class="w-full inputx"
              type="file"
              ref="file"
              accept=".jpg, .jpeg, .png, .xlxs, .doc, .docx, .pdf"
            />
          </div>
        </div>
      </div>
      <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
        <div class="vx-col sm:w-1/3 w-full">
          <span></span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <div class="vx-col sm:w-4/5 w-full">
            <vs-button class="mr-3 mb-2" @click="handleAttachment"
              >Add Attachment</vs-button
            >
          </div>
        </div>
      </div>
      <vs-divider style="width: 100%; margin-left: 2%"
        >List Attachment</vs-divider
      >
      <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
        <table class="vs-table vs-table--tbody-table">
          <div :key="`attachment-${i}`" v-for="(tr, i) in table.file">
            <tr class="tr-values vs-table--tr tr-table-state-null selected">
              <td class="td vs-table--td">{{ tr.file_name }}</td>
              <td class="td vs-table--td">
                <vx-tooltip text="Show" v-if="tr.path != ''">
                  <vs-button
                    type="line"
                    icon-pack="feather"
                    @click.stop="downloadFileAwsS3(tr.path)"
                    icon="icon-eye"
                  />
                </vx-tooltip>
              </td>
              <td class="td vs-table--td">
                <template>
                  <vx-tooltip text="Delete">
                    <vs-button
                      type="line"
                      icon-pack="feather"
                      @click.stop="handleDeleteAttachment(tr.id)"
                      icon="icon-trash"
                    />
                  </vx-tooltip>
                </template>
              </td>
            </tr>
          </div>
        </table>
      </div>
      <vs-divider style="width: 100%; margin-left: 2%"></vs-divider>

      <div class="flex gap-3">
        <vs-button class="mb-2" @click="handleSubmit"
          >Submit for Approval</vs-button
        >
        <vs-button class="mb-2" @click="handleBankSave" type="border"
          >Save</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import datepicker from "vuejs-datepicker";
import moment from "moment";
import XLSX from "xlsx";

export default {
  components: {
    datepicker,
    Date,
  },
  props: {
    piId: {
      type: Number,
    },
    vendor: {
      type: String,
    },
    poCode: {
      type: String,
    },
    invCode: {
      type: String,
    },
    warehouseCode: {
      type: String,
    },
    warehouseName: {
      type: String,
    },
    createdDate: {
      type: String,
    },
    advanceInvoiceID: {
      type: Number,
    },
  },
  created() {},
  data() {
    return this.initialState();
  },
  methods: {
    initialState() {
      return {
        porpose_date: null,
        debitNote: [],
        applyValue: [],
        applyID: [],
        optionDebitNote: [],
        optionPaymentTerm: [],
        optionBankName: [],
        optionSupplierAccount: [],
        optionOperatingUnitBank: [],
        operatingUnitBank: null,
        tr_number: null,
        tr_date: null,
        posting_date: null,
        search: "",
        comment: "",
        new_notes: "",
        offset: 0,
        limit: 10,
        status_submit: false,
        maxSelectedDN: 999,
        table: {
          inv_code: null,
          inv_date: null,
          due_date: null,
          payment_term: null,
          bank_name: null,
          account_name: null,
          account_number: null,
          total_inv_value: 0,
          item_value: 0,
          charges_value: 0,
          tax_value: 0,
          data: [],
          data_charges: [],
          line: [],
          file: [],
        },
        bank: null,
        total_paid: 0,
        total_unpaid: 0,
        total_process: 0,
        account_number: null,
        total_value: 0,
        canApplyDN: true,
        file: {},
        description: "",
        note: "",
        is_skb: false,
        vat_expired: false,
        advanceInvoice: null,
        supplierAddress: null,
        invoiceDate: null,
        supplierBank: null,
        supplierAcount: null,
        defaultAccount: null,
      };
    },

    async loadExcel() {
      console.log(this.$refs.fileSelected.files[0], "load");
      this.$vs.loading();
      var file = this.$refs.fileSelected.files[0];
      const data = await file.arrayBuffer();
      var workbook = XLSX.readFile(data, { dense: true });
      var worksheet = workbook.Sheets[workbook.SheetNames[0]];
      var json = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
      });
      console.log(json, "json");
      this.$vs.loading.close();
      document.querySelector("#fileSelectedDN").value = "";
      this.processSelectedDN(json);
      // }

      // reader.readAsArrayBuffer(file);
      // console.log(file)
    },
    handleMaxValue(index) {
      // return this.formatPrice(paid_now)
      // dataChecked[checked.length - 1].paid_now = formatPrice(
      //                 dataChecked[checked.length - 1].paid_now.toString() == ''? '0': (tr.unpaid_value < dataChecked[checked.length - 1].paid_now ? tr.unpaid_valuez.toString():dataChecked[checked.length - 1].paid_now.toString() )
      //               )
      if (
        Number(this.applyValue[index].toString().replace(/,/g, "")) >
        Number(
          this.debitNote[index].TotalDnValue - this.debitNote[index].UsedDnValue
        )
      ) {
        this.applyValue[index] = Number(
          this.debitNote[index].TotalDnValue - this.debitNote[index].UsedDnValue
        )
          .toString()
          .replace(/,/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.applyValue[index] = this.applyValue[index]
          .toString()
          .replace(/,/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      // this.$nextTick(() => {
      console.log(this.applyValue[index]);
      // return this.applyValue[index]
      // })
    },
    formatNumber() {
      if (
        Number(this.total_value.toString().replace(/,/g, "")) >
        Number(this.total_unpaid.toString().replace(/,/g, ""))
      ) {
        this.$vs.notify({
          color: "warning",
          title: "Information",
          text: "Check total unpaid.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        this.total_value = this.total_unpaid
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.total_value = Number(this.total_value.toString().replace(/,/g, ""))
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    handleSubmit() {
      this.status_submit = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          this.doSubmit();
        }
      });
    },
    handleDeleteAttachment(id) {
      // this.table.file = this.table.file.filter((item, i) => i != index);
      this.deleteFile(id);
      // console.log(this.table.file);
    },
    handleAttachment() {
      console.log(this.$refs.file.files[0]);

      if (this.$refs.file.files.length > 0) {
        this.file = this.$refs.file.files;
        for (let i = 0; i < this.$refs.file.files.length; i++) {
          console.log(i, "ini i");
          this.uploadData(i);
        }
        document.querySelector("#fileInput").value = "";
      } else {
        this.$vs.notify({
          title: "Error",
          text: "Please select file to import.",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
      }
    },
    handleShowAttachment(selected) {
      if (selected.path != "") {
        window.open(selected.path);
      }
    },
    paramUpload(index) {
      var form = new FormData();
      form.append("advance_invoice_id", this.advanceInvoiceID);
      form.append("file", this.file[index]);
      return form;
    },
    uploadData(index) {
      this.$vs.loading();
      this.$http
        .patch("/api/v1/advance-invoice/attachment", this.paramUpload(index), {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((resp) => {
          this.table.file.push({
            id: resp.data.ListID,
            file_name: resp.data.NameFile,
            path: resp.data.PathFile,
          });
          console.log("files gess", this.table.file);
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    deleteFile(attachment_id) {
      this.$vs.loading();
      this.$http
        .delete(`/api/v1/advance-invoice/attachment`, {
          params: {
            attachment_id,
            advance_invoice_id: this.advanceInvoiceID,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            const index = this.table.file.findIndex(
              (v) => v.id === resp.data.ListID
            );
            this.table.file.splice(index, 1);
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    doSubmit() {
      let param = {
        advance_invoice_id: this.advanceInvoiceID,
        // inv_code: this.invCode,
        // bank_id: this.bank.id ? this.bank.id : this.bank.ID,
        // bank_name: this.bank.name ? this.bank.name : this.bank.Name,
        account_number: this.supplierAcount.AccountNumber,
        account_name: this.supplierAcount.AccountName,
        bank_id: this.supplierBank.ID,
        bank_name: this.supplierBank.Name,
        porpose_date: moment(this.porpose_date).format("YYYY-MM-DD"),
        total_value: this.total_value,
        total_paid: this.total_paid,
        notes: this.new_notes,
        comment: this.comment,
        description: this.description,
        new_code:
          this.table.inv_code !== this.invCode ? this.table.inv_code : null,
      };
      this.$http
        .post("/api/v1/pi/propose-payment", param)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    handleClose() {
      window.scrollTo(0, 0);
      this.$emit("close");
    },
    async getSupplierBank(supplier_id, territory_id) {
      try {
        this.$vs.loading();
        const resp = await this.$http.get(
          `/api/v1/master/bank/supplier/${supplier_id}`,
          {
            params: {
              territory_id,
            },
          }
        );
        if (resp.code == 200) {
          this.optionSupplierAccount = resp.data.account;
          this.optionBankName = resp.data.bank;
          this.defaultAccount = resp.data.default_account;
        } else {
          this.$vs.notify({
            title: "Error",
            text: "Failed to get Supplier Bank",
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-check",
          });
        }
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        console.log(error);
      }
    },
    getOptionBankName() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/master/bank", {
          params: {
            order: "name",
            sort: "asc",
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.optionBankName = resp.data.records;
            console.log("INI RESPON DATA", resp.data);
          } else {
            this.$vs.notify({
              title: "Error",
              text: "Failed to get Bank Name option",
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          }
          this.$vs.loading.close();
          this.getData();
        });
    },
    handleApplyDebitNote() {
      this.$vs.loading();
      let totalUnpaid = parseFloat(
        this.total_unpaid.toString().replace(/,/g, "")
      );
      const debitNote = [];
      let valueApplied = [];
      this.debitNote.map((v) => {
        const dnValue = v.TotalDnValue - v.UsedDnValue;
        let dnApplied = 0;
        if (totalUnpaid >= dnValue) {
          dnApplied = dnValue;
          totalUnpaid = totalUnpaid - dnValue;
        } else {
          dnApplied = totalUnpaid;
          totalUnpaid = 0;
        }

        debitNote.push(v.ID);
        valueApplied.push(dnApplied);
      });
      valueApplied = this.applyValue.map((v) => {
        return parseFloat(v.toString().replace(/,/g, ""));
      });
      let param = {
        invoice_id: this.piId,
        debit_note: debitNote,
        value_applied: valueApplied,
        posting_date: this.posting_date,
      };
      // console.log(this.debitNote,param)
      this.$http
        .post("/api/v1/advance-invoice", param)
        .then((resp) => {
          this.applyValue = [];
          this.$vs.loading.close();
          this.getData();
          if (resp.code == 200) {
            // this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get(
          "/api/v1/advance-invoice/line-for-proposal/" + this.advanceInvoiceID
        )
        .then(async (resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            if (resp.data.unpaid_value == 0) {
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: this.invCode + " already paid",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
              });
              this.handleClose();
              return;
            }
            // this.table.inv_date =
            //   this.invCode != 0
            //     ? moment(String(new Date(resp.data.inv_date))).format(
            //         "DD/MM/YYYY"
            //       )
            //     : null;
            // this.table.due_date =
            //   this.invCode != 0
            //     ? moment(String(new Date(resp.data.due_date))).format(
            //         "DD/MM/YYYY"
            //       )
            //     : null;
            this.debitNote = [];
            this.advanceInvoice = resp.data.advance_invoice;
            const supplier = resp.data.supplier;
            await this.getSupplierBank(
              supplier.ID,
              this.advanceInvoice.territory_id
            );
            this.supplierAddress = supplier.Address;
            if (this.advanceInvoice.partner_bank_id) {
              this.supplierBank = this.optionBankName.find(
                (v) => v.ID == this.advanceInvoice.partner_bank_id
              );

              this.supplierAcount = this.optionSupplierAccount.find(
                (v) =>
                  v.AccountNumber ==
                    this.advanceInvoice.partner_bank_account_number &&
                  v.BankID == this.advanceInvoice.partner_bank_id
              );
            } else {
              this.supplierBank = this.optionBankName.find(
                (v) => v.ID == this.defaultAccount.BankID
              );

              this.supplierAcount = this.optionSupplierAccount.find(
                (v) =>
                  v.AccountNumber == this.defaultAccount.AccountNumber &&
                  v.BankID == this.defaultAccount.BankID
              );
            }
            this.description = this.advanceInvoice.description;
            this.note = this.advanceInvoice.notes;
            this.invoiceDate = moment.utc(this.advanceInvoice.date).toDate();
            this.table.line = resp.data.lines;
            this.table.file = this.advanceInvoice.attachment
              ? this.advanceInvoice.attachment.map((v) => ({
                  id: v.ListID,
                  file_name: v.NameFile,
                  path: v.PathFile,
                }))
              : [];
            // this.advanceInvoice.map((r, i) => {
            //   this.table.file.push({
            //     id: r.id,
            //     name: r.name,
            //     path: r.path,
            //   });
            // });
            this.total_value = resp.data.total_value
              .toFixed(2)
              .toString()
              .replace(/,/g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            console.log("total value gess", this.total_value);
            this.total_paid = resp.data.total_paid
              .toFixed(2)
              .toString()
              .replace(/,/g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.total_unpaid = resp.data.unpaid_value
              .toFixed(2)
              .toString()
              .replace(/,/g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.table.data_payment = resp.data.payment;
            // this.description = this.cnSupplier.Description;
            // this.notes = resp.data.invoice_notes.toString().split(";");
            // this.table.payment_term_name = resp.data.payment_term_name;
            // this.table.data_payment = resp.data.detail_payment;
            // this.table.bank_name =
            //   resp.data.bank_name +
            //   " - " +
            //   resp.data.account_number +
            //   " " +
            //   resp.data.account_name;
            // this.tr_date =
            //   moment(String(resp.data.tr_date)).format("YYYY-MM-DD") ==
            //   "0001-01-01"
            //     ? ""
            //     : moment(String(new Date(resp.data.tr_date))).format(
            //         "DD/MM/YYYY"
            //       );
            // this.tr_number = resp.data.tr_number;
            // this.table.discount_value = resp.data.total_discount
            //   .toFixed(2)
            //   .toString()
            //   .replace(/,/g, "")
            //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // this.total_paid = resp.data.paid_value
            //   .toFixed(2)
            //   .toString()
            //   .replace(/,/g, "")
            //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // this.table.total_whtax = resp.data.data_line.reduce(
            //   (accumulator, currentObj) => {
            //     if (resp.data.purchase_invoice.IsSkb === 1) {
            //       return accumulator;
            //     } else {
            //       return accumulator + currentObj.wh_tax;
            //     }
            //   },
            //   0
            // );
            // this.vat_expired =
            //   resp.data.purchase_invoice.VatExpired === 0 ? false : true;
            // this.is_skb = resp.data.purchase_invoice.IsSkb === 1 ? true : false;
            // this.total_unpaid = (
            //   resp.data.unpaid_value - this.table.total_whtax
            // )
            //   .toFixed(2)
            //   .toString()
            //   .replace(/,/g, "")
            //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // this.total_process = resp.data.proposal_value
            //   .toFixed(2)
            //   .toString()
            //   .replace(/,/g, "")
            //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // this.total_value = (resp.data.unpaid_value - this.table.total_whtax)
            //   .toFixed(2)
            //   .toString()
            //   .replace(/,/g, "")
            //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // this.table.total_whtax = this.table.total_whtax
            //   .toFixed(2)
            //   .toString()
            //   .replace(/,/g, "")
            //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // this.table.total_inv_value = resp.data.total_invoice_value
            //   .toFixed(2)
            //   .toString()
            //   .replace(/,/g, "")
            //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // this.table.item_value = resp.data.item_value
            //   .toFixed(2)
            //   .toString()
            //   .replace(/,/g, "")
            //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // this.table.charges_value = resp.data.charge_value
            //   .toFixed(2)
            //   .toString()
            //   .replace(/,/g, "")
            //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // this.table.tax_value = resp.data.tax_value
            //   .toFixed(2)
            //   .toString()
            //   .replace(/,/g, "")
            //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            // resp.data.debit_note.map((v, i) => {
            //   resp.data.debit_note[i].CreatedAt = moment(
            //     resp.data.debit_note[i].CreatedAt
            //   ).format("YYYY-MM-DD");
            // });
            this.optionDebitNote = resp.data.debit_notes;
            // this.optionOperatingUnitBank = resp.data.data_operating_unit_bank;
            // this.operatingUnitBank = this.optionOperatingUnitBank.filter(
            //   (v) => {
            //     return (
            //       v.BankID == resp.data.bank_id_proposal &&
            //       v.AccountNumber == resp.data.account_number_proposal
            //     );
            //   }
            // )[0];
            // this.table.po_code = resp.data.po_code;
            // this.table.vendor = resp.data.vendor;

            // let _this = this;
            // resp.data.data_line.forEach(function (element, index) {
            //   _this.table.data.push({
            //     net: element.net
            //       .toFixed(2)
            //       .toString()
            //       .replace(/,/g, "")
            //       .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            //     tax: element.tax
            //       .toFixed(2)
            //       .toString()
            //       .replace(/,/g, "")
            //       .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            //     quantity: element.quantity
            //       .toString()
            //       .replace(/,/g, "")
            //       .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            //     discount: element.discount
            //       .toFixed(2)
            //       .toString()
            //       .replace(/,/g, "")
            //       .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            //     item_name: element.item_name,
            //     item_unit: element.item_unit,
            //     id: element.id,
            //     qty_received: element.qty_received,
            //     subtotal: (element.net - element.discount)
            //       .toFixed(2)
            //       .toString()
            //       .replace(/,/g, "")
            //       .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            //     wh_tax: element.wh_tax
            //       .toFixed(2)
            //       .toString()
            //       .replace(/,/g, "")
            //       .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            //   });
            // });

            // resp.data.data_charge.forEach(function (element, index) {
            //   _this.table.data_charges.push({
            //     value: element.value
            //       .toString()
            //       .replace(/,/g, "")
            //       .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            //     tax: element.tax
            //       .toString()
            //       .replace(/,/g, "")
            //       .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            //     id: element.id,
            //     charge_name: element.charge_name,
            //     tax_rate: element.tax_rate,
            //   });
            // });
            // this.comment = resp.data.purchase_invoice.CommentInvoice;
            // resp.data.data_attachment.map((r, i) => {
            //   _this.table.file.push({
            //     id: r.id,
            //     name: r.name,
            //     path: r.path,
            //   });
            // });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    removeSelectedDN(...args) {
      for (var i = 0; i < this.debitNote.length; i++) {
        console.log(args[0].ID, this.applyID[i]);
        if (args[0].ID == this.applyID[i]) {
          this.applyID.splice(i, 1);
          this.applyValue.splice(i, 1);
          break;
        }
      }
      console.log(args, "args");

      this.maxSelectedDN = 999;
    },
    processSelectedDN(json) {
      this.$loa;
      console.log(json);
      json.map((v, r) => {
        if (r > 0 && v.length > 0) {
          const filter = this.optionDebitNote.filter((subv) => {
            return v[0] == subv.Code;
          });
          if (filter.length > 0) {
            const unUsed =
              parseFloat(filter[0].TotalDnValue) -
              parseFloat(filter[0].UsedDnValue);
            console.log(unUsed, v[2]);
            if (unUsed >= parseFloat(v[2])) {
              const checkSelected = this.debitNote.filter((subv) => {
                return v[0] == subv.Code;
              });
              if (checkSelected.length < 1) {
                this.debitNote.push(filter[0]);
                this.applyID.push(filter[0].ID);
                if (this.applyValue.length < this.debitNote.length) {
                  this.applyValue.push(parseFloat(v[2]));
                } else {
                  this.applyValue[this.applyValue.length - 1] = parseFloat(
                    v[2]
                  );
                }
              } else {
                this.$vs.notify({
                  color: "warning",
                  title: "Information",
                  text: v[0] + " already selected",
                  position: "top-right",
                  iconPack: "feather",
                  icon: "icon-x-circle",
                });
              }
            } else {
              this.$vs.notify({
                color: "warning",
                title: "Information",
                text: v[0] + " value greater than remaining debit note",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
              });
            }
          } else {
            this.$vs.notify({
              color: "warning",
              title: "Information",
              text: v[0] + " not found",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
          console.log(filter);
          console.log(v, r, "r");
        }
      });
      // this.optionDebitNote.map(item => {
      //   // console.log(item, 'item')
      // })
    },
    selectedDN(selectedOption, id) {
      console.log(selectedOption, id);
      console.log(this.total_unpaid);
      this.applyID.push(this.debitNote[this.debitNote.length - 1].ID);
      if (this.applyValue.length < this.debitNote.length) {
        this.applyValue.push(
          parseFloat(this.debitNote[this.debitNote.length - 1].TotalDnValue) -
            parseFloat(this.debitNote[this.debitNote.length - 1].UsedDnValue)
        );
      }
      console.log(this.debitNote);
      const totalSelectedDebitNote = this.applyValue.reduce(
        (prev, curr) => prev + curr,
        0
      );
      this.canApplyDN = true;
      console.log(this.debitNote.length);
      console.log(
        parseFloat(this.total_unpaid.toString().replace(/,/g, "")) <
          totalSelectedDebitNote,
        parseFloat(this.total_unpaid.toString().replace(/,/g, ""))
      );
      if (
        parseFloat(this.total_unpaid.toString().replace(/,/g, "")) <
        totalSelectedDebitNote
      ) {
        this.maxSelectedDN = this.debitNote.length;
        this.canApplyDN = false;
      }
    },
    handleBankSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          this.$http
            .patch(`/api/v1/advance-invoice/bank/${this.advanceInvoiceID}`, {
              bank_id: this.supplierBank.ID,
              bank_name: this.supplierBank.Name,
              account_number: this.supplierAcount.AccountNumber,
              account_name: this.supplierAcount.AccountName,
              description: this.description,
              notes: this.note,
            })
            .then((resp) => {
              this.$vs.loading.close();
              if (resp.code == 200) {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: resp.message,
                  position: "top-right",
                  iconPack: "feather",
                  icon: "icon-x-circle",
                });
                this.getData();
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: resp.message,
                  position: "top-right",
                  iconPack: "feather",
                  icon: "icon-x-circle",
                });
              }
            })
            .catch((error) => {
              this.$vs.loading.close();
              console.log(error);
            });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Please fill all required field",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
        }
      });
    },
    supplierAcoountQuery({ AccountName, AccountNumber }) {
      return `${AccountName} - ${AccountNumber}`;
    },
    onSupplierBankSelected(data) {
      this.optionSupplierAccount = this.optionSupplierAccount.filter((v) => {
        return v.BankID == data.ID;
      });

      if (this.supplierAcount && data.ID !== this.supplierAcount.BankID) {
        this.supplierAcount = null;
      }
    },
    onSupplierAccountSelected(data) {
      if (this.supplierBank && Object.keys(this.supplierBank).length > 0) {
        return;
      }

      this.supplierBank = this.optionBankName.find((v) => {
        return v.ID == data.BankID;
      });
    },
  },
  mounted() {
    this.porpose_date = new Date();
    this.getData();
  },
  computed: {},
  watch: {
    piId() {
      Object.assign(this.$data, this.initialState());
      // this.getData();
      this.getOptionBankName();
      this.table.inv_code = this.invCode != 0 ? this.invCode : null;
    },
    applyValue: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler() {
        this.debitNote.map((v, i) => {
          this.handleMaxValue(i);
        });
        const totalSelectedDebitNote = this.applyValue
          .map((v) => {
            return parseFloat(v.toString().replace(/,/g, ""));
          })
          .reduce((prev, curr) => prev + curr, 0);
        this.canApplyDN = true;
        this.maxSelectedDN = 9999;
        console.log(totalSelectedDebitNote);
        if (
          parseFloat(this.total_unpaid.toString().replace(/,/g, "")) <
          totalSelectedDebitNote
        ) {
          this.maxSelectedDN = this.debitNote.length;
          this.canApplyDN = false;
        }
      },
    },
  },
};
</script>
<style scoped>
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}

.pagination button {
  flex-grow: 1;
}

.pagination button:hover {
  cursor: pointer;
}

.horizontal-divider {
  border-top: 1px solid #c1bbff;
  padding: 5px;
  margin-top: 15px;
}
</style>
